import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Body } from 'syf-component-library/ui/typography';
import Inset from 'syf-component-library/ui/spacing/Inset';
import { useManageCardHolderModalContext } from '../../../context/manage-card-holder-modal-context';
import { Container, HeaderContainer, Label, MembershipNumberContainer, RadioGroupContainer, UserInfoContainer, UserNameContainer, UserRadioContainer } from './subcomponents';
import SamsSteps from '../SamsSteps';
import { translate } from '../../../strings/i18n';
const EligibleMemberList = () => {
    const { selectedSamsUser, eligibleMembers, updateSelectedSamsUser, updateIsAuthorizedUserSubmitted } = useManageCardHolderModalContext();
    const selectedUser = selectedSamsUser.value?.partnerId;
    useEffect(() => {
        updateSelectedSamsUser({
            touched: false,
            value: selectedUser ? selectedSamsUser.value : eligibleMembers[0],
            errorMessage: undefined
        });
        updateIsAuthorizedUserSubmitted(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleSelectUser = (partnerId) => {
        const selectedEligibleMember = eligibleMembers.filter(eligibleMember => eligibleMember.partnerId === partnerId)[0];
        updateSelectedSamsUser({
            touched: false,
            value: selectedEligibleMember,
            errorMessage: undefined
        });
        updateIsAuthorizedUserSubmitted(false);
    };
    return (_jsxs(Container, { children: [_jsxs(HeaderContainer, { bottom: "small", left: "medium", right: "medium", children: [_jsx(Body, { weight: "bold", children: translate('addAuthUserScreen.nameLabel') }), _jsx(Body, { weight: "bold", children: translate('addAuthUserScreen.membershipNumber') })] }), _jsx(RadioGroupContainer, { selected: selectedUser, onChange: handleSelectUser, children: eligibleMembers.map(eligibleMember => {
                    const { 'cipher.firstName': firstName, 'cipher.lastName': lastName, partnerId } = eligibleMember;
                    return (_jsx(UserRadioContainer, { id: partnerId, value: partnerId, name: `user-${partnerId}`, children: _jsxs(UserInfoContainer, { children: [_jsx(UserNameContainer, { children: `${firstName} ${lastName}` }), _jsx(Inset, { top: "xsmall", hideOnBreakpointUp: "small", children: _jsxs(MembershipNumberContainer, { children: [_jsxs(Label, { children: [translate('addAuthUserScreen.membershipNumber'), ' '] }), partnerId] }) })] }) }, partnerId));
                }) }), _jsx(SamsSteps, { title: translate('missingSomeone') })] }));
};
export default EligibleMemberList;
